import axios from "axios";
import endpointNames from "../configs/serverUrls";

//url variables
const baseUrl = endpointNames.employer;
const baseUrls = endpointNames.employers;

// get User Token
let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//store employer and representative
const storeEmployer = async (request) => {
    let response;
    const data = {
        "name": request.name,
        "email": request.email,
        "contact_number": request.contact_number,
        "street": request.street,
        "suburb": request.suburb,
        "status": 1,
        "city": request.city,
        "postal_address_street": request.postal_address_street,
        "postal_address_suburb": request.postal_address_suburb,
        "postal_address_city": request.postal_address_city,
    };
    await axios.post(baseUrl,data, {

            headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            //if status 200 call save representative
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;

}

//get all employers
const getAllEmployers = async () => {
    let response;
    // start
    //gets user from localStorage
    console.log("user: ", user);
    console.log("token: ", token);

    //create configuration with token
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
     //include the config in your request
     await axios.get(baseUrls , config)
         .then(res => {
             console.log("res: ", res)
             response = res.data.aggregators;

         }).catch(err => {
             console.log(err);
             response = err;
         });
    // end

    return response;
}

//get employer details
const getEmployerDetails = async (id) => {
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(baseUrl + '/' + id, config)
        .then(res => {
            console.log(res.data.aggregator);
            response = res.data.aggregator;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//update employer
const updateEmployer = async (request) => {
    console.log(request);
    let response;

    let data = {
        "name": request.name,
        "email": request.email,
        "contact_number": request.contact_number,
        "city": request.city,
        "street": request.street,
        "suburb": request.suburb,
        "postal_address_suburb": request.postal_address_suburb,
        "postal_address_street": request.postal_address_street,
        "postal_address_city": request.postal_address_city
    }

    console.log("data: ", data)
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };

    await axios.put(baseUrl + '/update/' + parseInt(request.employerId), data, config)
        .then(res => {
            console.log("update response", res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;

}

//delete employer
const deleteEmployer = async (id) => {
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.delete(baseUrl + '/' + id, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

async function activate(id){

    console.log("id: ", id)
    try{
        const response = await axios.post(baseUrl + '/activate/' + id,{}, {
            headers: {Authorization: `Bearer ${token}`},
        })
        return response;
    }catch (e) {
        console.log(e);
        return 0;
      }
}

async function deactivate(id){
    console.log("id: ", id)

    console.log("id: ", id)
    try{
        const response = await axios.post(baseUrl + '/de-activate/' + id,{}, {
            headers: {Authorization: `Bearer ${token}`},
        })
        return response;
    }catch (e) {
        console.log(e);
        return 0;
      }
}

export default {
    storeEmployer,getAllEmployers,getEmployerDetails,updateEmployer,deleteEmployer, activate, deactivate
}
